import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'ngx-work-appt-referred',
  templateUrl: './appt-referred.component.html',
})
export class ApptReferredComponent implements OnInit {

    private _pet_no: number;
    private _client_no: number;
    
    recall = false;
    notes = true;
  
    @Input() set pet_no(value: number) {
      this._pet_no = value;
    }
  
    get pet_no(): number {
      return this._pet_no;
    }

    @Input() set client_no(value: number) {
      this._client_no = value;
    }

    get client_no(): number {
      return this._client_no;
    }

    constructor() {

    }

    ngOnInit()  {

    }

    ver(tipo: string) {
      this.recall = tipo === 'recall'
      this.notes = tipo === 'notes'
    }
}